import { useMutation } from '@tanstack/react-query';

import { Vacancy, VacancyWithAtsJob } from 'clients/AutoCompleteClient/types';
import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { queryClient } from 'config/queryClient';
import { QueryKey } from 'types/query';
import { getVacancyName } from 'utils/vacancyEnrichedUtils';

export const useAutoProcessAtsVacancy = () => {
  return useMutation(
    async ({ atsVacancy }: { atsVacancy: Vacancy }): Promise<VacancyWithAtsJob> => {
      if (atsVacancy.type !== 'ATS_RAW') {
        throw Error('ATS_RAW is the only supported type when auto processing ATS vacancies');
      }

      const {
        data: { result },
      } = await reachoutClient.autoProcessAtsVacancy({ ats_vacancy_id: atsVacancy.job_ats_id });

      if (!result.job_ats_id) {
        throw Error('Processed vacancy has no ATS ID');
      }

      return {
        name: getVacancyName(result),
        value: result.job_ats_id,

        db_id: result.id,
        job_ats_id: result.job_ats_id,
        job_campaign_id: result.job_campaign_id,
        job_title: result.job_details.job_title,
        quality_percent: result.quality_percent,
        created_at: result.created_at,
        updated_at: result.updated_at,

        is_improved: true,
        type: 'ATS',
      };
    },
    {
      onSuccess: () => {
        queryClient.resetQueries([QueryKey.useEnrichedVacanciesQuery], { exact: false });
      },
    },
  );
};
